import type { EditControlProps } from '../../declare'
import { Input } from 'antd'

const AreaInput = (props: EditControlProps) => {
  const handleChange = (evt: any) => {
    props.onChange?.(evt.target.value)
  }

  const { __READONLY__, EDITABLE, PROMPT_INFO } = props.config
  return (
    <Input.TextArea
      disabled={__READONLY__ || !EDITABLE || props.evtConfig?.disabled}
      placeholder={PROMPT_INFO}
      rows={6}
      value={props.value}
      onChange={handleChange}
    />
  )
}

export default AreaInput